import { Alert, AlertTitle, Button, Container, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { useRef, useState } from "react";
import { FaPlus, } from "react-icons/fa";
import Loadingspinner from "../Components/loading";
import { getsessionuser } from "../Utils/sessions";
import { Fundwalleturl } from "../Utils/urls";



const Fundwallet = ({ onsuccessfund, onfailfund, oncancelfund }) => {
    const user = getsessionuser()


    //basics
    const [amount, setamount] = useState('');
    const [phone, setphone] = useState('2547');
    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');

    const [loading, setloading] = useState(false);

    const fund = () => {
        seterror()
        setloading(true)
        const formatedphone = phone.toString().substring(0, 2) == '07' ? phone.replace('07', '2547') : phone.toString().substring(0, 2) == '01' ? phone.replace('01', '2541') : phone.toString().substring(0, 3) == '+25' ? phone.replace('+', '') : phone;
        axios.post(Fundwalleturl, {
            email: user?.email,
            campus: user?.campus,
            amount: parseInt(amount),
            phone: formatedphone
        }).then(function (response) {
            setloading(false)
            if (!response.data.error) {
                setsuccess("Success.Complete payment on phone")
                setTimeout(() => {
                    setsuccess()
                    onsuccessfund()
                }, 3000);
              
            } else {
                seterror(response.data.message);
            }
            
        }).catch(function (error) {
            setloading(false)
            seterror("Sorry there was an error try again later")
            //if(error.response.status === 401 || error.response.status === 400){}

        });
    }





    return (
        <Container sx={{
            backgroundColor: "white",
            marginTop: 5,
            padding: 4,
        }} maxWidth="sm">
            {error?.length > 0 &&
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    {error} — <strong>check it out!</strong>
                </Alert>}
            {success?.length > 0 &&
                <Alert severity="success">
                    <AlertTitle>Success</AlertTitle>
                    {success}
                </Alert>}
            {loading && <Loadingspinner />}
            <div style={{ padding: 5 }}>
                <Container maxWidth="md" className="containerwithshadow" style={{ marginTop: 30 }}>
                    <Typography sx={{ fontWeight: "bold" }}>
                        Fund my wallet
                    </Typography>

                    <div style={{ marginTop: 30, flexWrap: "wrap" }}>
                        <div style={{ marginBottom: 15 }}>
                            <div style={{ fontSize: 15, marginTop: 5 }}>
                                Mpesa phone number:
                            </div>
                            <TextField
                                id="outlined-basic"
                                sx={{ maxHeight: 20, marginRight: 10, marginBottom: 2, width: "80%" }}
                                value={phone}
                                FormHelperTextProps={{ fontSize: 10 }}
                                onChange={(e) => setphone(e.target.value)}
                                inputProps={{ fontSize: 10 }}
                                placeholder="tel"
                                autoComplete="tel"
                                type={"tel"}
                                variant="outlined" size="small" /><br />
                        </div>
                        <div style={{ marginBottom: 15 }}>
                            <div style={{ fontSize: 15, marginTop: 5 }}>
                                Amount:
                            </div>
                            <TextField
                                id="outlined-basic"
                                sx={{ maxHeight: 20, marginRight: 10, marginBottom: 2, width: "80%" }}
                                value={amount}
                                FormHelperTextProps={{ fontSize: 10 }}
                                onChange={(e) => setamount(e.target.value)}
                                inputProps={{ fontSize: 10 }}
                                placeholder="amount"
                                type={"number"}
                                variant="outlined" size="small" /><br />
                        </div>

                        <div style={{ marginBottom: 15 }}>
                            <div>
                                <Button disabled={(!phone || !amount) && true} onClick={() => fund()} variant="contained" sx={{ height: 30, fontSize: 12, marginRight: 2 }}>Submit</Button>
                                <Button onClick={() => oncancelfund()} variant="contained" sx={{ height: 30, fontSize: 12 }}>Cancel</Button>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </Container>
    )
}

export default Fundwallet;